import BaseCtrl from 'edge/platform/base/BaseCtrl';
import Contact from 'edge/fnol/common/models/Contact';

const fn = ($scope, claimViewModel, LocaleService) => {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = () => {
        $scope.claimVm = claimViewModel();
        $scope.lobExtension = $scope.claimVm.lobs.workersComp;
        $scope.availableEmployees = $scope.claimVm.lobs.workersComp.value.getAvailableContacts();

        const {injuryIncident} = $scope.lobExtension.value;
        if (!injuryIncident.injured) {
            injuryIncident.injured = new Contact({
                displayName: 'New person',
                gender: null,
                dateOfBirth: null
            });
        }

        if (!injuryIncident.injured.primaryAddress) {
            injuryIncident.injured.initializePrimaryAddress();
        }

        $scope.phoneMask = LocaleService.getRegionSamplePhoneNumber().replace(/[0-8]/g, '9');
    };

    ctrl.next = (nextFn) => {
        nextFn($scope.claimVm);
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel', 'LocaleService'];

export default fn;
